export default __webpack_public_path__ + "static/developers-need-daa659758dbad1d7bb4e4ef87bbd3221.webp";